import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import styles from './OtpModal.module.css'
import '../../../assets/css/modal.css'
import { baseUrl, dataContext, portal } from '../../../App';
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate, useSearchParams } from 'react-router-dom';
import xImg from './assets/x.png'
import otpIcon from './assets/otp_icon.png'

const OtpModal = ({ showOtpModal, setShowOtpModal, activeBottom, setShowPaymentLoadingModal }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);
  const [otpCode, setOtpCode] = useState("");
  const [showErrorOutline, setShowErrorOutline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isOtpOkay, setIsOtpOkay] = useState(false);
  const [subscriptionService, setSubscriptionService] = useState(sessionStorage.getItem('subscriptionServiceType'));
  const [errorMessage, setErrorMessage] = useState(``);
  const [searchParams, setSearchParams] = useSearchParams();
  let navigate = useNavigate();

  // Add resend timer state
  const [resendTimer, setResendTimer] = useState(299); // 5 minutes in seconds

  // Timer effect
  useEffect(() => {
    let timer;
    if (showOtpModal && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev > 0 ? prev - 1 : 0);
      }, 1000);
    }
    // If timer reaches 0, close the modal
    if (showOtpModal && resendTimer === 0) {
      setShowOtpModal(false);
      sessionStorage.removeItem("subscriptionServiceType");
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [showOtpModal, resendTimer, setShowOtpModal]);

  // Reset timer when modal is opened
  useEffect(() => {
    if (showOtpModal) {
      setResendTimer(299);
    }
  }, [showOtpModal]);

  let subscriptionQuizName = (subscriptionService == 'Daily')?'কুইজ প্রতিদিন':(subscriptionService == 'Sports')?'Sports কুইজ':(subscriptionService == 'Tournament')?'টুর্নামেন্ট কুইজ':(subscriptionService == 'BCS')?'BCS কুইজ':'';
  const config = {
    headers: { Authorization: `Token ${token}` },
  };
  function hideModalOperation() {
    setShowOtpModal(false);
    sessionStorage.removeItem("subscriptionServiceType")
  }
  function checkOtp() {
    var otpPattern = /^\d{5}$/;
    if (otpCode.match(otpPattern)) {
      console.log(otpCode,'true')
      return true;
    } else {
      console.log(otpCode,'false')
      return false;
    }
  }
  function submitOperation() {
    console.log(otpCode)
    axios
      .post(
        `${baseUrl}/api/v1/telco/payment/bl/subscription/otp/consent/`,
        { otp: otpCode, portal: portal, msisdn: localStorage.getItem("user_msisdn"), service_type: sessionStorage.getItem("subscriptionServiceType") },
        config
      )
      .then((response) => {
        console.log(response?.data)
        if(response?.data?.error){
          setShowError(true);
          setErrorMessage(response?.data?.resultParam?.resultDescription)
          return;
        }
        setShowOtpModal(false);
        setShowPaymentLoadingModal(true);
      }).catch(error => {
        console.log(error);
        if (error?.response?.data?.error) {
          setShowError(true);
          setErrorMessage(error?.response?.data?.error)
        }
      })
  }

  return (
    <>
      <Modal show={showOtpModal} centered dialogClassName={styles.otpModalDialog} contentClassName={styles.otpModalContent} onHide={hideModalOperation} backdrop="static">
        <img src={xImg} alt="logo" className={styles.xImg} onClick={()=>{
          hideModalOperation();
          if(activeBottom === "campaign"){
            navigate("../");
          }
        }} />
        <Modal.Body className={styles.otpModalBody}>
          <img src={otpIcon} alt="logo" className={styles.otpIcon} />
          <div className={styles.infoContainer}>
            <span className={styles.infoText}>OTP দিন</span>
            <span>{subscriptionQuizName}</span>
            <span>৩০ টাকা ট্যাক্স সহ ৭ দিনের জন্য</span>
            <span>**অটো রিনিউয়াল প্রযোজ্য</span>
            <span style={{fontSize:'14px'}}>মোবাইলে পাঠানো ওটিপি দিন, মেয়াদ ৫ মিনিট।</span>
            <div className={styles.inputContainer}>
              <span>OTP Timer: {Math.floor(resendTimer / 60)}:{(resendTimer % 60).toString().padStart(2, '0')}</span>
              <span className={`${styles.inputSpan}`}>
                <input
                  type="number"
                  maxLength={6}
                  minLength={6}
                  onKeyUp={(e) => {
                    setOtpCode(e.target.value);
                    setIsOtpOkay(checkOtp());
                  }}
                  onChange={(e) => {
                    setOtpCode(e.target.value);
                    setIsOtpOkay(checkOtp());
                  }}
                  onKeyDown={(e) => e.key === 'Enter' && submitOperation()}
                  id="otpCode"
                  name="otpCode"
                  placeholder="OTP নম্বর দিন"
                  className={styles.inputFieldOtp}
                />{" "}
              </span>
              {showError && <div style={{ color: "#ff0000", textAlign: 'center', fontWeight: 600 }}>* {errorMessage}</div>}
              <button
                type="button"
                className={`btn ${styles.numberSubmit}`}
                onClick={submitOperation}
                disabled={!isOtpOkay}
                style={{ backgroundColor: !isOtpOkay ? "#757575" : "#FB005D" }}
              >
                {isLoading ? (
                  <Spinner animation="border" variant="light" size="sm" />
                ) : (
                  "সাবমিট করুন"
                )}
              </button>
            </div>
          </div>

          {/* End */}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default OtpModal